import {PreparationType} from '@cypro/engine/database/schema'
import * as z from 'zod'

export const DEFAULT_SCALE_INCREMENT_FACTOR = 0.005

export const CleanroomSearchSchema = z.object({
  productionLocationId: z.uuidv7().optional(),
  sequenceId: z.uuidv7().optional(),
  navOpen: z.boolean().default(true),
  workflow: z
    .enum([
      'bolusSingle',
      'inPrefilledSingle',
      'inPrefilledMultiple',
      'adPrefilledSingle',
      'adPrefilledMultiple',
      'adEmpty',
      'bolusSolid',
      'solidConcentrationUnits',
      'inPrefilledMultipleSolid',
      'bolusSolidNoCarrier',
    ])
    .optional(),
  mockScale: z.boolean().optional(),
  mockWorkflow: z.boolean().optional(),
  scaleIncrementFactor: z.number().optional(),
  preparationType: PreparationType.optional(),
})
export type CleanroomSearchSchema = z.infer<typeof CleanroomSearchSchema>
